export const EXCHANGE_TYPE_FIAT = 'fiat'
export const EXCHANGE_TYPE_CRYPTO = 'crypto'

export const EXCHANGE_STORAGE_KEY = 'exchange-storage'
export const EXCHANGE_PAGE_STORAGE_KEY = 'exchange-page-storage'
